export default __webpack_public_path__ + "static/media/verve.48820e28.svg";